//@ts-ignore
export const eth = window.ethereum;


export async function retrievePublicAddress(): Promise<string | void> {
    try {
        const publicAddressArray = await eth.request({
            method: 'eth_requestAccounts',
        });
        return publicAddressArray[0];
    } catch (error) {
        console.warn(error.message);
    }
}


export async function getSignature(
    publicAddress: string,
    nonce: string,
) {
    return eth.request({
        method: 'personal_sign',
        params: [
            `
        Connect your wallet in order to sync your avatar profile into Metaverse Chat. 
        Unique ID/Nonce: ${nonce}
        `,
            publicAddress,
        ],
    });
}


// export const metaMaskInstalled = eth.isMetaMask;
